module.exports = __webpack_public_path__ + "static/home-bg-02eb0bbf80accbccc69c31102eb227a5.jpg";